import { render, staticRenderFns } from "./PassengerInformations.vue?vue&type=template&id=12f25820&scoped=true"
import script from "./PassengerInformations.vue?vue&type=script&lang=js"
export * from "./PassengerInformations.vue?vue&type=script&lang=js"
import style0 from "./PassengerInformations.vue?vue&type=style&index=0&id=12f25820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f25820",
  null
  
)

export default component.exports